import { BlockDefinition } from '../../types'
import { createEmptyRichText } from '../../richText/emptyContent'
import TextBlock from './TextBlock'

// Legacy equivalents: text, plus cheader / csubheader headings folded in
const textBlock: BlockDefinition<'text'> = {
  type: 'text',
  createDefaultProps: () => ({ body: createEmptyRichText() }),
  Component: TextBlock
}

export default textBlock
